module.exports = __webpack_public_path__ + "static/media/video2.fc4f76e6.mp4";